export const GID_BASE_PRODUCT = 'gid://shopify/Product/'
export const GID_BASE_PRODUCT_VARIANT = 'gid://shopify/ProductVariant/'
export const GID_BASE_BLOG = 'gid://shopify/Blog/'
